module.exports = __webpack_public_path__ + "img/GENERAL.b0fd29bc.jpg";